<template>
  <div class="crear-cotizacion screen page formActions b-soft">
    <div class="grid">
      <formVersion 
      v-on:actionChange="onActionChange" />
      <GetFooter />
    </div>
  </div>
</template>

<script>
import formVersion from '@/components/form-version.vue'
import GetFooter from '@/components/footer.vue'
export default {
  name: 'app',
  components: {
    formVersion,
    GetFooter
  },
  data() {
    return {
      action_state: true
    }
  },
  beforeRouteLeave (to, from, next) {
    if(this.isEditing === true){
      const answer = window.confirm('¿Estás Seguro? Se perderá la información que se haya modificado')
      if(answer){
        next()
      }
    }else{
      next()
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav)
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    })
  },
  methods: {
    onActionChange(getactionChange){
      this.isEditing = getactionChange
    },
    preventNav(event) {
      if (!this.isEditing) return
      event.preventDefault()
    },
  },
}
</script>